import React from 'react';
import { motion } from 'framer-motion';
export function ProductMockup() {
  return <section className="py-8 px-4 bg-neutral-950" data-id="element-121">
      <div className="container mx-auto max-w-5xl" data-id="element-122">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative rounded-3xl overflow-hidden bg-neutral-900 border border-neutral-800 p-6 md:p-10 flex justify-center" data-id="element-123">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,107,0,0.15)_0%,transparent_70%)] pointer-events-none" data-id="element-124" />

          <img src="https://cdn.magicpatterns.com/uploads/aH4AqsJLgX8BVCTV2Mq2CL/mockup_primeros_auxilios.png" alt="Mockup de la Guía de Primeros Auxilios Felinos en Tablet y Celular" className="w-full max-w-3xl h-auto object-contain relative z-10 drop-shadow-2xl" data-id="element-125" />
        </motion.div>
      </div>
    </section>;
}